/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g clipPath="url(#clip0_2004_9234)">
				<path
					opacity="0.4"
					d="M7.00003 14L17.5 1.5M17.5 14L12.25 7.75M10.36 5.5L7.00003 1.5"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M22 18C22 20.2091 20.2092 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2092 14 22 15.7909 22 18Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 18C10 20.2091 8.20917 22 6.00003 22C3.79089 22 2.00003 20.2091 2.00003 18C2.00003 15.7909 3.79089 14 6.00003 14C8.20917 14 10 15.7909 10 18Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_9234">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g clipPath="url(#clip0_2004_9237)">
				<g opacity="0.12">
					<path
						d="M22 18C22 20.2091 20.2092 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2092 14 22 15.7909 22 18Z"
						fill="currentColor"
					/>
					<path
						d="M10 18C10 20.2091 8.20917 22 6.00003 22C3.79089 22 2.00003 20.2091 2.00003 18C2.00003 15.7909 3.79089 14 6.00003 14C8.20917 14 10 15.7909 10 18Z"
						fill="currentColor"
					/>
				</g>
				<path
					d="M7.00006 14.0002L17.5001 1.50024M17.5001 14.0002L12.2501 7.75024M10.3601 5.50024L7.00006 1.50024M22 18.0002C22 20.2093 20.2092 22.0002 18 22.0002C15.7909 22.0002 14 20.2093 14 18.0002C14 15.791 15.7909 14.0002 18 14.0002C20.2092 14.0002 22 15.791 22 18.0002ZM10.0001 18.0002C10.0001 20.2094 8.2092 22.0002 6.00006 22.0002C3.79092 22.0002 2.00006 20.2094 2.00006 18.0002C2.00006 15.7911 3.79092 14.0002 6.00006 14.0002C8.2092 14.0002 10.0001 15.7911 10.0001 18.0002Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_9237">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_9244)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.57427 1.01762C7.30785 0.700459 6.83476 0.659321 6.5176 0.92574C6.20043 1.19216 6.15929 1.66525 6.42571 1.98241L9.78571 5.98241C10.0521 6.29958 10.5252 6.34072 10.8424 6.0743C11.1596 5.80788 11.2007 5.33479 10.9343 5.01762L7.57427 1.01762ZM18.0709 1.98637C18.3395 1.67105 18.3017 1.19769 17.9863 0.929086C17.671 0.660482 17.1977 0.698351 16.9291 1.01367L6.48471 13.2744C6.32534 13.2583 6.16363 13.25 6 13.25C3.37664 13.25 1.25 15.3766 1.25 18C1.25 20.6234 3.37664 22.75 6 22.75C8.62335 22.75 10.75 20.6234 10.75 18C10.75 16.1194 9.65712 14.4941 8.07182 13.7244L12.1936 8.88586L16.0029 13.689C14.3773 14.4433 13.25 16.09 13.25 18C13.25 20.6234 15.3766 22.75 18 22.75C20.6234 22.75 22.75 20.6234 22.75 18C22.75 15.3766 20.6233 13.25 18 13.25C17.8597 13.25 17.7208 13.2561 17.5836 13.268L13.185 7.722L18.0709 1.98637Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_9244">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<g clipPath="url(#clip0_2004_9232)">
				<path
					d="M14 18C14 20.2091 15.7909 22 18 22C20.2092 22 22 20.2091 22 18C22 15.7909 20.2092 14 18 14C16.9856 14 16.0593 14.3776 15.3542 15M7.00003 14L17.5 1.5M17.5 14L12.25 7.75M10.36 5.5L7.00003 1.5M10 18C10 20.2091 8.20917 22 6.00003 22C3.79089 22 2.00003 20.2091 2.00003 18C2.00003 15.7909 3.79089 14 6.00003 14C8.20917 14 10 15.7909 10 18Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_9232">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<g clipPath="url(#clip0_2004_9230)">
				<path
					d="M7.00002 14L17.5 1.5M17.5 14L12.25 7.75M10.36 5.5L7.00002 1.5M22 18C22 20.2091 20.2092 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2092 14 22 15.7909 22 18ZM10 18C10 20.2091 8.20915 22 6.00002 22C3.79088 22 2.00002 20.2091 2.00002 18C2.00002 15.7909 3.79088 14 6.00002 14C8.20915 14 10 15.7909 10 18Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_9230">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_9240)">
				<path
					opacity="0.32"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.51768 0.925739C6.83485 0.65932 7.30794 0.700458 7.57436 1.01762L10.9344 5.01762C11.2008 5.33479 11.1596 5.80788 10.8425 6.0743C10.5253 6.34071 10.0522 6.29958 9.7858 5.98241L6.4258 1.98241C6.15938 1.66525 6.20052 1.19216 6.51768 0.925739ZM17.9864 0.929085C18.3017 1.19769 18.3396 1.67105 18.071 1.98637L13.1851 7.722L17.398 13.034C17.6554 13.3585 17.601 13.8303 17.2765 14.0876C16.9519 14.345 16.4802 14.2906 16.2228 13.9661L12.1937 8.88586L8.35463 13.3926L7.84879 13.9864C7.58019 14.3017 7.10683 14.3396 6.79151 14.0709C6.47619 13.8023 6.43832 13.329 6.70693 13.0137L7.21276 12.4199L16.9291 1.01367C17.1978 0.69835 17.6711 0.660481 17.9864 0.929085Z"
					fill="currentColor"
				/>
				<path
					d="M18.0001 13.25C15.3768 13.25 13.2501 15.3766 13.2501 18C13.2501 20.6234 15.3768 22.75 18.0001 22.75C20.6235 22.75 22.7501 20.6234 22.7501 18C22.7501 15.3766 20.6235 13.25 18.0001 13.25Z"
					fill="currentColor"
				/>
				<path
					d="M6.00012 13.25C3.37677 13.25 1.25012 15.3766 1.25012 18C1.25012 20.6234 3.37677 22.75 6.00012 22.75C8.62347 22.75 10.7501 20.6234 10.7501 18C10.7501 15.3766 8.62347 13.25 6.00012 13.25Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_9240">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
